import { Component } from '@theme/component';

/**
 * @typedef {{ track: HTMLElement, pool: HTMLTemplateElement }} GuideRefs
 * @extends {Component<GuideRefs>}
 */
class SAHomeGuides extends Component {
  requiredRefs = ['track', 'pool'];

  /** @type {AbortController | undefined} */
  #controller;

  /** @type {MediaQueryList | undefined} */
  #desktopQuery;

  #sourceSignature = '';

  /** @type {Element[]} */
  #desktopCards = [];

  /** @type {Element[]} */
  #mobileCards = [];

  connectedCallback() {
    super.connectedCallback();
    this.#controller?.abort();
    this.#controller = new AbortController();
    this.#desktopQuery = window.matchMedia('(min-width: 990px)');
    this.#desktopQuery.addEventListener('change', this.#render, { signal: this.#controller.signal });
    this.#prepareCards();
    this.#render();
  }

  updatedCallback() {
    super.updatedCallback();
    this.#prepareCards();
    this.#render();
  }

  disconnectedCallback() {
    this.#controller?.abort();
    super.disconnectedCallback();
  }

  #prepareCards() {
    const desktopLimit = Number(this.dataset.desktopLimit) || 4;
    const mobileLimit = Number(this.dataset.mobileLimit) || 3;
    const signature = `${desktopLimit}:${mobileLimit}:${this.refs.pool.innerHTML}`;
    if (signature === this.#sourceSignature) return;

    const articles = [...this.refs.pool.content.querySelectorAll('.sa-post')];
    const shuffled = [...articles];
    for (let index = shuffled.length - 1; index > 0; index--) {
      const next = Math.floor(Math.random() * (index + 1));
      [shuffled[index], shuffled[next]] = [shuffled[next], shuffled[index]];
    }

    this.#desktopCards = shuffled.slice(0, desktopLimit);
    this.#mobileCards = shuffled.slice(0, mobileLimit);
    this.#sourceSignature = signature;
  }

  #render = () => {
    const articles = this.#desktopQuery?.matches ? this.#desktopCards : this.#mobileCards;
    this.refs.track.replaceChildren(...articles.map((article) => article.cloneNode(true)));
    this.refs.track.scrollLeft = 0;
  };
}

if (!customElements.get('sa-home-guides')) {
  customElements.define('sa-home-guides', SAHomeGuides);
}

